<template>
	<b-navbar toggleable type="dark" variant="dark" >

		<b-navbar-brand>
			<div class="col-6">
				<a :href="'http://ligasound.ru'"> <b-img :src="'/src/assets/logo_liga.png'"

					class="d-inline-block align-top logo"	
					fluid alt="Responsive image" /></a>
				</div>

			</b-navbar-brand>
			<b-collapse is-nav id="nav_text_collapse">
				<b-navbar-nav>
					<h2><b-nav-text>Мы несем людям свет и звук</b-nav-text></h2>
				</b-navbar-nav>
             <!--b-nav-form class="right">
			      <b-form-input class="mr-sm-3" type="text" placeholder="Search"></b-form-input>
			      <b-button variant="outline-success" class="my-2 my-sm-0" type="submit">Search</b-button>
			  </b-nav-form-->
			</b-collapse>
	</b-navbar>
</template>

<script>
	export default{
		data (){
			return{

			}
		}
	};
</script>

<style scoped>
	.navbar-collapse{
		justify-content: space-around;
	}
	.navbar{

		margin-bottom: 20px;
	}
	.col-6{
		background: #fff;
		max-width: 100%;
		border-radius: 5px;
    	padding: 5px 20px;
	}
	.logo{
		min-width: 250px;
	}
	
	.navbar-text{
		text-transform: uppercase;
		color: #fff
	}
	.navbar-brand{
		display: flex;
    	justify-content: center;
	}

</style>